export function getFromSessionStorage<T>(key: string, defaultValue: T): T {
    try {
        const item = window.sessionStorage.getItem(key);
        return item ? JSON.parse(item) : defaultValue;
    } catch {
        return defaultValue;
    }
}

export function setToSessionStorage<T>(key: string, value: T): void {
    try {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.error('Error saving to sessionStorage:', error);
    }
}

export function removeFromSessionStorage(key: string): void {
    window.sessionStorage.removeItem(key);
}

export const sessionStorageUtils = {
    get: getFromSessionStorage,
    set: setToSessionStorage,
    remove: removeFromSessionStorage,
};
